import { render, staticRenderFns } from "./KBFiles.vue?vue&type=template&id=ce92807e&scoped=true"
import script from "./KBFiles.vue?vue&type=script&lang=js"
export * from "./KBFiles.vue?vue&type=script&lang=js"
import style0 from "./KBFiles.vue?vue&type=style&index=0&id=ce92807e&prod&lang=scss"
import style1 from "./KBFiles.vue?vue&type=style&index=1&id=ce92807e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce92807e",
  null
  
)

export default component.exports